export default __webpack_public_path__ + "static/media/ship.0add48ea.png";